<template>
  <div class="mobile-have-qrcode">
    <div class="success-result-info">
      <img class="icon" src="../../../assets/images/dui-icon.png" alt="" />
      <p>恭喜您，交易成功！</p>
    </div>
    <!-- 小助手 -->
    <div v-if="showAssistant" class="qrcode-wrap-helper">
      <p class="title">{{ orderInfo.assistant.guide }}</p>
      <img
        class="qrcode"
        :src="orderInfo.assistant.img_url + '?imageView2/0/w/400'"
        alt=""
      />
      <p class="type-tips" v-html="typeTips"></p>
      <div v-if="orderInfo.assistant.contact_way" class="copy-wrap">
        <p class="contact-number">{{ orderInfo.assistant.contact_way }}</p>
        <button class="copy-btn" @click="copyNumber">
          <img src="../../../assets/images/copy-icon.png" alt="" />
        </button>
      </div>
    </div>
    <!-- 默认 -->
    <div v-else class="qrcode-wrap">
      <div class="title">
        <p>扫码关注魔果云课服务号</p>
        <p>及时获取课程通知</p>
      </div>
      <img
        class="qrcode"
        src="https://cdn.moguocdn.com/image/web_assets/qrcode_for_gh_d94af974800d_430_3.png"
        alt=""
      />
    </div>
    <!-- 课程信息/联报信息 -->
    <div class="course-info-wrap">
      <img
        class="cover"
        :src="
          handleImageUrl(courseInfo.goods_cover_url) + '?imageView2/0/w/200'
        "
        alt=""
      />
      <p class="course-title">
        {{ courseInfo.goods_title }}
      </p>
    </div>

    <!-- 操作 -->
    <button v-if="!union_id" class="go-study-btn" @click="jumpStudy">
      立即上课
    </button>
    <button v-else class="go-study-btn" @click="goLearningCenter">
      去学习中心
    </button>
  </div>
</template>

<script>
import { handleImageUrl } from "@saas/components/src";
export default {
  props: {
    number: {
      type: String,
      default: "",
    },
    typeTips: {
      type: String,
      default: "",
    },
    showAssistant: {
      type: Boolean,
      default: false,
    },
    orderInfo: {
      type: Object,
      default: () => {},
    },
    union_id: {
      type: Number,
      default: null,
    },
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      handleImageUrl,
    };
  },
  methods: {
    jumpStudy() {
      this.$emit("jumpStudy");
    },
    goLearningCenter() {
      this.$emit("goLearningCenter");
    },
    copyNumber() {
      this.$emit("copyNumber");
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-have-qrcode {
  padding-bottom: 1rem;
  .success-result-info {
    margin-bottom: 0.53rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 0.85rem;
      height: 0.85rem;
      margin-right: 0.43rem;
    }
    font-weight: 500;
    font-size: 0.64rem;
    color: #0d1400;
    line-height: 0.88rem;
  }
  // 小助手
  .qrcode-wrap-helper {
    position: relative;
    width: 8rem;
    // height: 12.05rem;
    margin: 0 auto;
    background: linear-gradient(42deg, #daffef 0%, #ffffff 100%);
    border-radius: 0.43rem;
    margin-bottom: 0.77rem;
    padding: 0.64rem 0.43rem 0.64rem;
    .title {
      width: 6.93rem;
      height: 1.44rem;
      border-radius: 0.21rem;
      background: rgba($color: #ffffff, $alpha: 0.6);
      font-weight: 500;
      font-size: 0.43rem;
      color: #0d1400;
      line-height: 0.64rem;
      margin: 0 auto 0.37rem;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    .qrcode {
      width: 5.33rem;
      max-height: 6.929rem;
      margin: 0 auto 0.53rem;
    }
    ::v-deep .type-tips {
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.64rem;
      margin-bottom: 0.37rem;
      span {
        font-weight: bold;
      }
    }
    .copy-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 6.93rem;
      height: 1.44rem;
      background: #ffffff;
      border-radius: 0.21rem;
      border: 0.03rem solid #00c89d;
      margin: 0 auto;
      padding: 0 0.21rem 0 0.21rem;
      font-weight: 500;
      font-size: 0.8rem;
      color: #0d1400;
      line-height: 1;
      .copy-btn {
        width: 0.37rem;
        height: 0.37rem;
        margin-left: 0.21rem;
      }
      .contact-number {
        flex: 1;
        width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-break: anywhere;
        text-align: center;
      }
    }
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      content: "";
      width: 1.57rem;
      height: 1.36rem;
      background-image: url("../../../assets/images/logo-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  // 默认
  .qrcode-wrap {
    position: relative;
    width: 8rem;
    // height: 12.05rem;
    margin: 0 auto;
    background: linear-gradient(42deg, #daffef 0%, #ffffff 100%);
    border-radius: 0.43rem;
    margin-bottom: 0.53rem;
    padding: 0.64rem 0 1.01rem;
    .title {
      text-align: center;
      font-weight: 500;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.64rem;
      margin-bottom: 0.53rem;
    }
    .qrcode {
      width: 5.33rem;
      height: 5.33rem;
      margin: 0 auto;
    }
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      content: "";
      width: 1.57rem;
      height: 1.36rem;
      background-image: url("../../../assets/images/logo-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  // 课程信息/联报信息
  .course-info-wrap {
    display: flex;
    align-items: center;
    width: 8rem;
    height: 2.13rem;
    border-radius: 0.32rem;
    border: 0.01rem solid #efefef;
    padding: 0.32rem;
    margin: 0 auto 0.37rem;
    .cover {
      width: 2.67rem;
      height: 1.49rem;
      border-radius: 0.24rem;
      margin-right: 0.27rem;
      object-fit: cover;
    }
    .course-title {
      height: 1.18rem;
      flex: 1;
      width: 0;
      font-weight: 500;
      font-size: 0.43rem;
      color: #0d1400;
      line-height: 0.59rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
  .go-study-btn {
    display: block;
    width: 8rem;
    height: 1.07rem;
    font-weight: 600;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.59rem;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 0.53rem;
    margin: 0 auto;
  }
}
</style>
